import { useQuery } from '@apollo/client/react/hooks/useQuery';
import { gql } from '@yi/core';

export function useUserFavoritesByIds(ids: string[]) {
  const { data, loading, error, refetch } = useQuery<
    gql.typesClient.Query_CurrentUser_FavoritesBase,
    gql.typesClient.Query_CurrentUser_FavoritesBaseVariables
  >(gql.Query_CurrentUser_FavoritesBase, {
    variables: { ids },
    context: {
      batch: true,
    },
  });

  return {
    favorites: data?.CurrentUser_Favorites || [],
    loading,
    error,
    refetch,
  };
}
